// @flow
import React, { Component } from 'react'
import _ from 'lodash'
import LabeledWrapper from './LabeledWrapper'
import Checkbox from '../controls/Checkbox'
import { InputCell } from '../AudienceEdit'

type Props = {|
  disclaimerFinance: boolean,
  financeName: string,
  financeNameErrors: Array<string>,
  financeLicenseNumber: string,
  financeLicenseNumberErrors: Array<string>,
  disclaimerMedical: boolean,
  disclaimerSpecialist: boolean,
  disclaimerSupplements: boolean,
  onChange: Function
|}

const t = {
  disclaimer_finance: 'Финансовая лицензия',
  finance_name: 'Наименование организации',
  finance_license_number: 'Номер лицензии',
  disclaimer_medical: 'Имеются противо- показания',
  disclaimer_specialist: 'Необходима консультация специалиста',
  disclaimer_supplements: 'БАД. Не является лекарственным препаратом'
}

export default class VkDisclaimers extends Component<Props> {
  render() {
    const {
      disclaimerFinance,
      financeName,
      financeNameErrors,
      financeLicenseNumber,
      financeLicenseNumberErrors,
      disclaimerMedical,
      disclaimerSpecialist,
      disclaimerSupplements
    } = this.props
    return (
      <div>
        {this.renderCheckbox('disclaimerFinance', disclaimerFinance)}
        {disclaimerFinance && this.renderInput('financeName', financeName, financeNameErrors)}
        {disclaimerFinance &&
          this.renderInput(
            'financeLicenseNumber',
            financeLicenseNumber,
            financeLicenseNumberErrors
          )}
        {this.renderCheckbox('disclaimerMedical', disclaimerMedical)}
        {this.renderCheckbox('disclaimerSpecialist', disclaimerSpecialist)}
        {this.renderCheckbox('disclaimerSupplements', disclaimerSupplements)}
      </div>
    )
  }

  renderCheckbox(key: string, value: boolean) {
    const labelBlock = (
      <span className={`t-VkDisclaimer__${key}`} onClick={() => this.onCheckboxChange(key, !value)}>
        {t[_.snakeCase(key)]}
      </span>
    )

    return (
      <LabeledWrapper label={labelBlock} twoLines>
        <div className="jq-checkbox">
          <Checkbox onChange={(checked) => this.onCheckboxChange(key, checked)} checked={value} />
        </div>
      </LabeledWrapper>
    )
  }

  onCheckboxChange(key: string, value: boolean) {
    const { onChange } = this.props
    if (key === 'disclaimerFinance') {
      onChange({
        [key]: value,
        financeName: '',
        financeNameErrors: [],
        financeLicenseNumber: '',
        financeLicenseNumberErrors: []
      })
    } else {
      onChange({ [key]: value })
    }
  }

  renderInput(key: string, value: string, errors: Array<string>) {
    const { onChange } = this.props
    const labelBlock = <span>{t[_.snakeCase(key)]}</span>

    return (
      <LabeledWrapper label={labelBlock} errors={errors} twoLines>
        <InputCell>
          <input
            type="text"
            id={`audience_${_.snakeCase(key)}`}
            value={value || ''}
            onChange={(e) => onChange({ [key]: e.target.value, [`${key}Errors`]: [] })}
            className="input-item input-item_full-width"
          />
        </InputCell>
      </LabeledWrapper>
    )
  }
}
